<script setup lang="ts">

import dayjs from "dayjs";
import { ref } from "vue";
import type { ConfigureConditionViewModel } from "..";

const model = defineModel<ConfigureConditionViewModel>( { required: true } );
const condition = model.value.condition;
const dueDate = condition.date.next.isValid() ? condition.date.next : dayjs().add( 1, 'day');
const months = model.value.getFutureMonthlyRange( dueDate, 24 );
const moreIndex = months.length;
const lessIndex = months.length - 12;
const maxIndex = ref( lessIndex );
const nextYear = new Date().getFullYear() + 1;

</script>

<template>

    <div class="text-base text-center flex flex-col pb-4 tracking-wider">
                
        <h1 class="leading-tight my-6 px-4 lg:px-8 tracking-wider">
            Choose your next reminder
        </h1>

        <Button v-if="model.condition.isDue || model.condition.isOverdue"
                variant="outlined"
                class="rounded-lg lg:!h-11 mb-5 mx-auto -mt-2"
                @click="model.markDone()">
            <span>Use Default Reminder</span>
        </Button>

        <div class="grid grid-cols-4 tracking-widest">
        
            <template v-for="(date,index) in months">
                <div v-if="index != 0 && date.month() == 0 && index < maxIndex" 
                     class="px-4 lg:px-6 col-span-4">
                    <div class="text-sm py-3 my-2 uppercase">
                        {{ date.year() == nextYear ? 'Next year' : date.year() }}
                    </div>
                </div>
                <div v-ripple
                     v-if="index < maxIndex"
                     class="aspect-square flex flex-col items-center justify-center 
                            m-2 cursor-pointer border border-gray-500 rounded-lg
                            text-lg"
                     :class="{ 
                         'text-cyan-400 !border-cyan-500 bg-cyan-500/20': date.isSame( dueDate, 'month' ),
                         'pointer-events-none opacity-50 !border-transparent': date.startOf( 'month' ).isBefore( model.today )
                     }"
                     @click="() => model.onSelectNext( date )">
                    <div v-if="date.isSame( dueDate, 'month' )"
                         class=" absolute w-3/4 h-3/4 rounded">
                    </div>
                    <div class="leading-tight brightness-125">
                        {{ date.format( 'MMM') }}
                    </div>
                    <div class="text-sm opacity-60 leading-none">
                        {{ date.format( 'YYYY') }}
                    </div>
                </div>
            </template>

            <div class="col-span-4 flex flex-col">
                <button v-ripple
                        class="py-4 tracking-widest flex items-center justify-center"
                        @click="() => maxIndex = ( maxIndex == lessIndex ? moreIndex : lessIndex )">
                    {{ maxIndex == moreIndex ? 'Show Less' : 'Show More' }}
                    <Icon v-if="maxIndex == moreIndex" name="chevron-up" class="text-2xl" />
                    <Icon v-else name="chevron-down" class="text-2xl" />
                </button>
            </div>

        </div>

    </div>

</template>